import { createSelector } from 'reselect'

const getCheckout = state => state.checkout

export const getShippingForm = createSelector(
  [getCheckout],
  checkout => checkout.shippingForm
)
export const getCalculationApiError = createSelector(
  [getCheckout],
  checkout => checkout.calculation && checkout.calculation.apiError
)

export const isPickupSelected = createSelector(
  [getCheckout],
  checkout => checkout.isPickupSelected
)

export const isTablePickupSelected = createSelector(
  [getCheckout],
  checkout => checkout.isTablePickupSelected
)

export const getIsTableNumberFilled = createSelector(
  [getCheckout],
  checkout => checkout && checkout.table_number.value !== ''
)

export const getIsUsaSelected = createSelector(
  [getShippingForm, isPickupSelected],
  (shippingForm, isPickupSelected) =>
    shippingForm &&
    shippingForm.country_code &&
    shippingForm.country_code.value === 'US' &&
    !isPickupSelected
)

export const getIsZipcodeFilled = createSelector(
  [getShippingForm],
  shippingForm => shippingForm && shippingForm.postal_code.value !== ''
)

export const getIsApiCalculationValid = createSelector(
  [getCalculationApiError],
  apiError => !apiError
)
